import { render, staticRenderFns } from "./VehicleAdd.vue?vue&type=template&id=c0f0668c"
import script from "./VehicleAdd.vue?vue&type=script&lang=js"
export * from "./VehicleAdd.vue?vue&type=script&lang=js"
import style0 from "./VehicleAdd.vue?vue&type=style&index=0&id=c0f0668c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports